(function () {
  function moveFilterRow() {
    var introSection = document.querySelector('.asl-collection-intro')?.closest('.shopify-section');
    var intro = introSection && introSection.querySelector('.asl-collection-intro');
    var cards = introSection && introSection.querySelector('.asl-favorites');
    if (!introSection || !intro || !cards) return false;
    var rows = document.querySelectorAll('.product-filter-row');
    var row = null;
    rows.forEach(function (candidate) {
      if (!introSection.contains(candidate)) row = candidate;
    });
    if (!row) return introSection.contains(rows[0]);
    var host = introSection.querySelector('.asl-mist-filter-host');
    if (!host) {
      host = document.createElement('div');
      host.className = 'collection-filter-gallery-wrapper asl-mist-filter-host';
      intro.insertAdjacentElement('afterend', host);
    }
    host.appendChild(row);
    return true;
  }
  var observer = new MutationObserver(function () {
    if (moveFilterRow()) observer.disconnect();
  });
  if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (moveFilterRow()) observer.disconnect();
    }, { once: true });
  } else if (moveFilterRow()) {
    observer.disconnect();
  }
})();